module.exports = __webpack_public_path__ + "img/ic_32_exercises_unterkoerper.9aa80dc0.svg";